import { useModuleBEM } from "@b2bportal/core-themes";
import { CoreFlightsComponent } from "@b2bportal/core-types";
import { PriceBreakdown } from "@hsbc/flights";

import { useFlightExchangePriceBreakdown } from "./useFlightExchangePriceBreakdown";

export interface IFlightExchangePriceBreakdownProps {
  showFareDescription?: boolean;
}

export const FlightExchangePriceBreakdown = (
  props: IFlightExchangePriceBreakdownProps
) => {
  const { context, text } = useFlightExchangePriceBreakdown(props);
  const [block] = useModuleBEM({}, CoreFlightsComponent.FlightPriceBreakdown);

  return (
    <PriceBreakdown
      className={block}
      currencyString={context.currency}
      priceLineItems={context.priceLineItems}
      subtitle={text.subtitle}
      summaryLineItems={context.summaryLineItems}
      title={text.title}
    />
  );
};
